/*
 * @Author: huangzq
 * @Date: 2020-01-06 15:53:55
 * @Last Modified by: huangzq
 * @Last Modified time: 2020-03-20 15:28:09
 * @Desc: H5-iframe预览组件
*/
<template>
  <div class="preview-wrapper">
    <!-- 预览内容：手机部分 -->
    <div
      v-loading="loading"
      class="preview-content"
    >
      <img
        class="phone-img"
        src="@/assets/images/phone.png"
        alt="phone"
        width="340"
      >
      <iframe
        :src="previewData.linkUrl+'&iframeEvent=yes&view=yes'"
        class="preview-iframe"
        frameborder="0"
        @load="iframeOnLoad"
      />

      <!-- 上一页、下一页 -->
      <div
        v-show="showPrevAndNext"
        class="prev-and-next"
      >
        <div
          class="prev"
          @click="postMessage('prev')"
        >
          上一页
        </div>
        <div
          class="next"
          @click="postMessage('next')"
        >
          下一页
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'H5Preview',
  props: {
    // 预览数据
    previewData: {
      type: Object,
      default () {
        return null
      }
    },
    // 是否 显示上一页、下一页操作
    showPrevAndNext: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      loading: true,
      previewIframeDom: null
    }
  },
  methods: {
    // iframe加载完成回调
    iframeOnLoad () {
      this.loading = false
      this.previewIframeDom = document.querySelector('.preview-iframe')
      this.$emit('iframe-loaded', this.previewIframeDom)
    },

    postMessage (eventName) {
      this.previewIframeDom.contentWindow.postMessage({
        postType: 'event',
        postData: { eventName }
      }, this.previewData.linkUrl)
    }
  }
}
</script>

<style lang='scss' scoped>
.preview-wrapper {
  .preview-content {
    position: relative;
    min-width: 300px;
    width: 300px;
    height: 504px;

    .phone-img {
      position: absolute;
      top: -36px;
      left: -20px;
      z-index: -1;
    }

    .preview-iframe {
      width: 100%;
      height: 100%;
    }

    // 上一页、下一页
    .prev-and-next {
      position: absolute;
      top: 50%;
      right: -10px;
      transform: translate(100%, -50%);

      .prev,
      .next {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 50px;
        height: 93px;
        font-size: 15px;
        color: #595959;
        writing-mode: vertical-lr;
        border-radius: 0 4px 4px 0;
        background-color: #e8e8e8;

        @extend .cursor;

        &:hover {
          color: #fff;
          background-color: #009cff;
        }
      }

      .prev {
        margin-bottom: 10px;
      }
    }
  }
}
</style>
